import { Component, OnInit } from '@angular/core';
import { BaseForm } from '../../../interfaces/BaseForm';
import { LogService } from '../../../services/log.service';
import { LoginService } from '../../../services/login.service';
import { UserValidationService } from '../../../services/user-validation.service';

@Component({
  selector: 'app-mfa-self-registration',
  templateUrl: './mfa-self-registration.component.html',
  styleUrls: ['./mfa-self-registration.component.scss']
})
export class MfaSelfRegistrationComponent extends BaseForm implements OnInit {
  phone: string;

  constructor(
    private log: LogService,
    private login: LoginService,
    private validationService: UserValidationService
  ) {
    super(log);
  }

  ngOnInit() {}

  isValid(): boolean {
    return !this.isSubmitInProgress && !!this.phone;
  }

  clear() {
    this.phone = '';
  }

  submit() {
    this.isSubmitInProgress = true;

    if (!this.validationService.isPhone(this.phone)) {
      this.clear();
      this.isSubmitInProgress = false;
      this.errorMsg = 'Invalid phone number';
      return;
    }

    this.log.trace('responding to auth challenge', this.login.getChallenge());
    this.login.respondToSelfMfaChallenge(this.phone, this.onErrorCallback);
  }
}
